import { FC } from "react";
import { TableCell, TableRow, Typography } from "@material-ui/core";
import { useStyles } from "./style";
import { DaFeedbackReport } from "types/DaFeedback";
import { useNav } from "hooks/useNav";
import Alert from "@material-ui/lab/Alert";
import useResize from "hooks/useResize";
import moment from "moment";

interface PropsType {
  data: DaFeedbackReport;
}

const DaFeedbackRow: FC<PropsType> = ({ data }) => {
  const classes = useStyles();
  const { width } = useResize();
  const { viewDaFeedbackReport } = useNav();

  return (
    <TableRow
      hover
      key={data.id}
      onClick={() => viewDaFeedbackReport(data.id)}
    >
      <TableCell style={{ cursor: "pointer" }} colSpan={1} className={`${classes.tableCell}`}>
        <Typography>{data.title}</Typography>
      </TableCell>
      {width > 900 && (
        <TableCell style={{ cursor: "pointer" }} colSpan={1} className={`${classes.tableCell}`}>
          <Typography>{data.content.slice(0, 90)}...</Typography>
        </TableCell>
      )}
      <TableCell style={{ cursor: "pointer" }} colSpan={1} className={`${classes.tableCell}`}>
        <Typography>{moment(data.created).format("YYYY-MM-DD")}</Typography>
      </TableCell>
      {[2, 3].includes(data.type) ? (
        <TableCell style={{ cursor: "pointer" }} colSpan={1} className={`${classes.tableCell}`}>
          {data?.is_submitted ? (
            <Alert severity="success" className={classes.alertColor}>
              Submitted
            </Alert>
          ) : (
            <Alert severity="warning" className={classes.warningColor}>
              Pending
            </Alert>
          )}
        </TableCell>
      ) : (
        <TableCell style={{ cursor: "pointer" }} colSpan={1} className={`${classes.tableCell}`}>
          <Alert severity="info">Info</Alert>
        </TableCell>
      )}
    </TableRow>
  );
};

export default DaFeedbackRow;
